const UPDATE_ACTIVE_WALLET_TYPE = 'UPDATE_ACTIVE_WALLET_TYPE';

export { UPDATE_ACTIVE_WALLET_TYPE };
